import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { getRowLabelProps } from '../positioning/row-labels';
import { SeatPickerContextInstance } from '../types/context';
import { SeatPickerRowLabel } from './row-label';
const b = bemClassBuilder('v-seat-picker-row-labels');
export const SeatPickerRowLabels = observer(props => {
    const { seatLayout, scaleFactor, mapRectangle, width } = props;
    const { config } = useContext(SeatPickerContextInstance);
    const rowLabels = getRowLabelProps(seatLayout, scaleFactor, config, mapRectangle);
    return (_jsx("svg", { className: b.block(), viewBox: `0 0 ${width} ${mapRectangle.height}`, preserveAspectRatio: "xMidYMid meet", children: rowLabels.map(rowLabelProps => (_createElement(SeatPickerRowLabel, Object.assign({}, rowLabelProps, { key: rowLabelProps.key })))) }));
});
SeatPickerRowLabels.displayName = 'SeatPickerRowLabels';
//# sourceMappingURL=row-labels.js.map